import {TARGET_TYPES} from '@/utils/constants/saleTargetConstants';

export const DEFAULT_INTL = 'en-US';

export const SALES_TARGETS_QUERY_KEY = 'salesTargets';

export const COUNTRIES_QUERY_KEY = 'countries';
export const LANGUAGES_QUERY_KEY = 'languages';

export const OKTA_AUTH_CONFIG_KEY = 'okta-auth-config';
export const OKTA_TOKEN_STORAGE_KEY = 'okta-token-storage';
export const SALES_TARGETS_ACTIVITIES_QUERY_KEY = 'salesTargetsActivities';
export const TEXT_TAG_ACTIVATION_CHAR = '$';
export const SALES_TARGET_MAIN_GROUP = [
  TARGET_TYPES.MainTarget,
  TARGET_TYPES.ProductTarget,
  TARGET_TYPES.ProductTargetLayered,
  TARGET_TYPES.MonthlyTargetLayered
];

export const SALES_TARGET_PREREQUISITE_GROUP = [
  TARGET_TYPES.MonthlyTargetPrerequistite,
  TARGET_TYPES.ProductTargetPrerequisite
];

export const COUNTRY_CODES = {
  EGYPT: 'EG',
  KSA: 'SA',
  MEXICO: 'MX',
  PERU: 'PE',
  ECUADOR: 'EC',
  COLOMBIA: 'CO',
  ARGENTINA: 'AR',
  DOMINICAN_REPUBLIC: 'DO',
  TURKEY: 'TR',
  POLAND: 'PL',
  CHILE: 'CL',
  ROMANIA: 'RO',
  SPAIN: 'ES',
  PORTUGAL: 'PT',
  RUSSIA: 'RU',
  THAILAND: 'TH',
  NEW_ZEALAND: 'NZ',
  UAE: 'AE',
  GUATEMALA: 'GT'
};

export const COUNTRY_CODES_FREQUENCY = [];
export const COUNTRY_CODES_EXCLUDE_TAX_FROM_GOAL = [
  COUNTRY_CODES.KSA,
  COUNTRY_CODES.TURKEY,
  COUNTRY_CODES.ROMANIA,
  COUNTRY_CODES.SPAIN,
  COUNTRY_CODES.PORTUGAL,
  COUNTRY_CODES.RUSSIA
];

export const COUNTRY_CODES_DISABLE_TAX_FROM_GOAL = [
  COUNTRY_CODES.TURKEY,
  COUNTRY_CODES.ROMANIA,
  COUNTRY_CODES.SPAIN,
  COUNTRY_CODES.PORTUGAL,
  COUNTRY_CODES.RUSSIA
];

export const APPLICATION_ID = {
  MX: 1,
  EG: 30,
  PE: 528,
  EC: 33,
  PR: 2, // Puerto Rico
  KSA: 29,
  SA: 29,
  CO: 7,
  AR: 500,
  TR: 14,
  ES: 13,
  PT: 16,
  NZ: 17,
  RO: 18
};

export const ALLOWED_ACTIVITY_SEGMENT_MARKETS = [
  COUNTRY_CODES.EGYPT,
  COUNTRY_CODES.THAILAND
];

export const COUNTRY_LANGUAGES_CODES = {
  MX: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'es_MX',
      title: 'Spanish (Mexico)'
    }
  ],
  PE: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'es_PE',
      title: 'Spanish (Peru)'
    }
  ],
  EC: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'es_EC',
      title: 'Spanish (Ecuador)'
    }
  ],
  EG: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'ar_EG',
      title: 'Arabic- Egypt'
    }
  ],
  SA: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'ar_SA',
      title: 'Arabic- KSA'
    }
  ],
  AR: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'es_AR',
      title: 'Spanish (Argentina)'
    },
    {
      languageId: 3,
      code: 'zh_AR',
      title: 'Chinese (Argentina)'
    }
  ],
  TR: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'tr_TR',
      title: 'Turkish'
    }
  ],
  DO: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'es_DO',
      title: 'Spanish (Dominican Republic)'
    }
  ],
  CO: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'es_CO',
      title: 'Spanish (Colombia)'
    }
  ],
  RO: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'ro',
      title: 'Romanian'
    }
  ],
  ES: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'es',
      title: 'Spanish (Spain)'
    },
    {
      languageId: 3,
      code: 'zh',
      title: 'Chinese (Simplified)'
    }
  ],
  PT: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'pt',
      title: 'Portuguese'
    }
  ],
  CL: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'es_CL',
      title: 'Spanish (Chile)'
    }
  ],
  PL: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'pl_PL',
      title: 'Polish (Poland)'
    }
  ],
  RU: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'ru',
      title: 'Russian (Russia)'
    }
  ],
  TH: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'th_TH',
      title: 'Thai (Thailand)'
    }
  ],
  NZ: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    }
  ],
  GT: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'es_GT',
      title: 'Spanish (Guatemala)'
    }
  ],
  AE: [
    {
      languageId: 1,
      code: 'en',
      title: 'English'
    },
    {
      languageId: 2,
      code: 'ar_AE',
      title: 'Arabic (UAE)'
    }
  ]
};
